import React, { Component } from "react";
import { createStackNavigator } from '@react-navigation/stack';
import UserProfile from './UserProfileScreen.js';
import {
    Container,
    Header,
    Title,
    Button,
    IconNB,
    DeckSwiper,
    Card,
    CardItem,
    Icon,
    Thumbnail,
    Text,
    Left,
    Right,
    Body,
    Footer,
    List, ListItem,Content
  } from "native-base";

export default function SettingsScreen({ route, navigation }) {
    return (
        <Container>
            <Content>
                <List>
                    <ListItem itemHeader first>
                        <Text>Profile</Text>
                    </ListItem>
                    <ListItem>
                        <Text>Profile Pictures</Text>
                    </ListItem>
                    <ListItem last button onPress={() => navigation.navigate('SettingsStack', {screen: 'UserProfile'})}>       
                        <Text>Personal Info</Text>
                    </ListItem>
                    <ListItem last button onPress={() => navigation.navigate('SettingsStack', {screen: 'MatchingData'})}>       
                        <Text>Matching Data</Text>
                    </ListItem>
                    <ListItem itemHeader>
                        <Text>Credentials</Text>
                    </ListItem>
                    <ListItem>
                        <Text>Password Reset</Text>
                    </ListItem>
                </List>
            </Content>
        </Container>
    )
}